// NOVA COFFEE — cohérent, fictif, prérempli
export const NOVA_DEMO = {
  demo: true,
  onboarding: {
    business_name: "NOVA COFFEE", country: "France", city: "Lyon",
    activity_type: "Café / Restaurant", company_size: "TPE", employees: "4",
    facebook: true, instagram: true, google: true, website: true, loyalty_program: true,
    promo_frequency: "hebdomadaire", events_frequency: "mensuel",
    posting_frequency: "hebdomadaire", main_goal: "Augmenter la clientèle en semaine",
  },
  scores: {
    global: 74,
    subs: { visibilite: 78, fidelisation: 71, reputation: 82, animation: 63, presence_digitale: 85, potentiel: 69 },
    opportunities: 6,
  },
  history: [
    { month: "Jan", score: 58 }, { month: "Fév", score: 61 }, { month: "Mar", score: 64 },
    { month: "Avr", score: 67 }, { month: "Mai", score: 70 }, { month: "Juin", score: 74 },
  ],
  actions: [
    { id: "a1", title: "Lancer l'offre \"Mardi Découverte\" -20%", impact: "Impact potentiel : jusqu'à +8 Visibilité", channel: "Instagram", done: false, sub: "visibilite", why: "Votre sous-score Visibilité est un de vos axes à renforcer. Une offre mise en avant sur vos réseaux augmente votre présence auprès des clients proches." },
    { id: "a2", title: "Demander 15 avis Google cette semaine", impact: "Impact potentiel : jusqu'à +6 Réputation", channel: "SMS / QR", done: false, sub: "reputation", why: "Collecter des avis récents renforce votre Réputation en ligne et rassure les nouveaux clients qui vous découvrent sur Google." },
    { id: "a3", title: "Animation dégustation samedi 14h", impact: "Impact potentiel : jusqu'à +10 Animation", channel: "En boutique", done: false, sub: "animation", why: "Votre sous-score Animation peut progresser. Un temps fort en boutique crée du trafic et de l'attachement à votre commerce." },
  ],
  completed: [
    { id: "c1", title: "Fiche Google Business complétée", date: "12 juin" },
    { id: "c2", title: "Programme fidélité relancé", date: "8 juin" },
  ],
  calendar: [
    { id: "e1", day: 2, type: "publication", title: "Post latte art", channel: "Instagram" },
    { id: "e2", day: 4, type: "promotion", title: "Happy Hour -30%", channel: "Facebook" },
    { id: "e3", day: 6, type: "animation", title: "Dégustation Éthiopie", channel: "Boutique" },
    { id: "e4", day: 9, type: "publication", title: "Story recette", channel: "Instagram" },
    { id: "e5", day: 13, type: "campagne", title: "Campagne fidélité", channel: "WhatsApp" },
    { id: "e6", day: 18, type: "evenement", title: "Soirée jazz", channel: "Boutique" },
    { id: "e7", day: 22, type: "tache", title: "Répondre aux avis", channel: "Google" },
    { id: "e8", day: 26, type: "publication", title: "Nouvelle carte automne", channel: "Facebook" },
  ],
  reputation: { average: 4.6, evolution: 0.3, count: 218, monthly_goal: 30, gained: 18,
    reviews: [
      { name: "Camille R.", rating: 5, text: "Le meilleur café de Lyon, ambiance parfaite pour travailler !" },
      { name: "Thomas L.", rating: 4, text: "Excellent flat white, un peu d'attente le midi." },
      { name: "Sarah M.", rating: 5, text: "Personnel adorable et pâtisseries maison délicieuses." },
    ] },
  loyalty: { clients: 1240, active: 812, to_reactivate: 186, campaigns: 4, purchase_freq: "2,3 / mois",
    segments: [ { name: "Fidèles", value: 320 }, { name: "Réguliers", value: 492 }, { name: "Occasionnels", value: 242 }, { name: "À réactiver", value: 186 } ] },
  gamification: { streak: 7, level: "Commerçant Pro", xp: 740, badges: [
    { name: "Premier plan lancé", icon: "rocket" }, { name: "7 jours d'activité", icon: "flame" },
    { name: "Score +15", icon: "trending-up" }, { name: "50 avis collectés", icon: "star" },
  ] },
  recent: [
    { text: "Business Score +3", time: "il y a 2h", type: "score" },
    { text: "Mission terminée : Fiche Google", time: "hier", type: "mission" },
    { text: "Nouvelle campagne fidélité créée", time: "il y a 2 j", type: "campaign" },
    { text: "12 nouveaux avis reçus", time: "il y a 3 j", type: "review" },
  ],
};

// Traductions EN/ES des ACTIONS du scénario Café/NOVA (FR = source ci-dessus, inchangé).
// Ne traduit que titre / justification / canal des actions affichées (Dashboard démo + plan).
export const NOVA_ACTIONS_I18N = {
  a1: {
    title: { en: 'Launch the "Tuesday Discovery" -20% offer', es: 'Lanza la oferta "Martes Descubierta" -20%' },
    why: { en: "Your Visibility sub-score is one of your areas to strengthen. A promoted offer on your social channels boosts your presence with nearby customers.", es: "Tu subpuntuación de Visibilidad es uno de tus ejes a reforzar. Una oferta destacada en tus redes aumenta tu presencia entre los clientes cercanos." },
    channel: { en: "Instagram", es: "Instagram" },
  },
  a2: {
    title: { en: "Ask for 15 Google reviews this week", es: "Pide 15 reseñas de Google esta semana" },
    why: { en: "Collecting recent reviews strengthens your online Reputation and reassures new customers who discover you on Google.", es: "Recopilar reseñas recientes refuerza tu Reputación online y tranquiliza a los nuevos clientes que te descubren en Google." },
    channel: { en: "SMS / QR", es: "SMS / QR" },
  },
  a3: {
    title: { en: "Tasting event Saturday 2 PM", es: "Evento de degustación sábado 14 h" },
    why: { en: "Your Engagement sub-score can improve. An in-store highlight drives traffic and builds attachment to your business.", es: "Tu subpuntuación de Animación puede mejorar. Un momento fuerte en tienda genera tráfico y apego a tu negocio." },
    channel: { en: "In-store", es: "En tienda" },
  },
};

export const SUB_LABELS = {
  visibilite: "Visibilité", fidelisation: "Fidélisation", reputation: "Réputation",
  animation: "Animation", presence_digitale: "Présence digitale", potentiel: "Potentiel",
};

export const CAL_COLORS = {
  publication: "#6366F1", promotion: "#00E5FF", animation: "#F59E0B",
  evenement: "#EC4899", campagne: "#10B981", tache: "#94A3B8",
};
